(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.listService', [])
        .factory('newOrderListService', NewOrderListService);

    function NewOrderListService() {
        return {
            getListOptions: getListOptions,
            updateList: updateList
        };

        function getListOptions(getListFunc, template, dataValueField) {
            var dataSource = new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: read
                }
            });

            return {
                filter: "contains",
                dataValueField: dataValueField,
                valueTemplate: template,
                template: template,
                dataSource: dataSource
            };

            function read(options) {
                var filter = _.getPath(options, "data.filter.filters.0.value");
                if (filter) {
                    var filteredItems = _.deepFilterByStr(getListFunc() || [], filter);
                    options.success(filteredItems);
                } else {
                    options.success((getListFunc() || []).slice());
                }
            }
        }

        function updateList(list) {
            if (list && list.dataSource && list.dataSource.read) {
                list.dataSource.read();
            }
        }
    }

})(window.angular);
